import React, { Component } from "react";
import PropTypes from "prop-types";
import DynamicGrid from "../DynamicGrid";
import { InpsectionDialog } from "../InspectionDialog";
var Settings = {
	ShowDateFilter: false,
	SortColumn: "is_primary",
	UseTicketTypeFilter: false,
	ShowNewButton: true,
	NewButtonText: "Upload Report",
};

class InspectionReports extends Component {
	constructor(props) {
		super(props);
		this.state = {
			Contacts: [],
			ModalVisible: false,
			SelectedContact: {},
			ModalData: null,
		};
		this.getData();
		this.FilePrompt = this.FilePrompt.bind(this);
		this.OpenFile = this.OpenFile.bind(this);
		this.closeModal = this.closeModal.bind(this);
		Settings.NewButtonAction = this.FilePrompt;
		Settings.ShowNewButton = !this.props.IsClientPortal;
	}

	closeModal() {
		this.setState({ ModalVisible: false });
		this.getData();
	}

	componentDidUpdate(prevProps) {
		if (this.props.BuildingID !== prevProps.BuildingID) {
			this.getData();
		}
	}

	OpenFile(row) {
		var url = document.location.origin + "/Inspection/" + row.inspection_reports_id;
		window.open(url, "_blank");
	}

	FilePrompt(row) {
		this.setState({ ModalVisible: true, ModalData: row });
		// this.refs.reportUpload.click();
	}

	async getData() {
		if (this.props.BuildingID) {
			const data = await fetch("Inspection/GetInspections", {
				method: "Post",
				cache: "no-cache",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(this.props.BuildingID),
			});
			var res = await data.json();
			this.setState({ Contacts: res });
		}
	}
	render() {
		var config = [
			{
				header: "Inspection",
				columnName: "description",
				visible: true,
				typeCode: "S",
			},
			{
				header: "Inspection Date",
				columnName: "date_entered",
				visible: true,
				typeCode: "D",
			},
			{ header: "Elevator", columnName: "elevator", visible: true, typeCode: "S" },
		];
		if (!this.props.IsClientPortal) {
			config.push({
				header: "Edit",
				columnName: "edit",
				visible: true,
				Condition: function (row) {
					return true;
				},
				OnClick: (row) => this.FilePrompt(row),
				typeCode: "ACTION",
				style: { minWidth: "80px" },
			});
		}

		return (
			<div
				style={{
					flex: 1,
					backgroundColor: "#ebebeb",
					overflowY: "auto",
					padding: "4px",
				}}>
				<input type="file" ref="reportUpload" style={{ display: "none" }} onChange={this.SaveFile}></input>
				<InpsectionDialog ModalData={this.state.ModalData} OnClose={this.closeModal} ModalVisible={this.state.ModalVisible} BuildingID={this.props.BuildingID}></InpsectionDialog>
				<DynamicGrid Title="Inspection Reports" Configuration={config} DataSet={this.state.Contacts} Settings={Settings} OnRowClick={(row) => this.OpenFile(row)} />
			</div>
		);
	}
}

InspectionReports.propTypes = {
	BuildingID: PropTypes.string,
};

export default InspectionReports;
